import { patchState, signalStore, withMethods, withState } from "@ngrx/signals"

export type NavState = {
	isOpen: boolean
}

export const NavStore = signalStore(
	{ providedIn: "root"},
	withState<NavState>({
		isOpen: true
	}),
	withMethods((store) => ({
		open(): void {
			patchState(store, {
				isOpen: true
			})
		},
		close(): void {
			patchState(store, {
				isOpen: false
			})
		}
	}))
)
